import React from 'react'

const COLORS = {
  ACTIVE: '#FF8200',
  INACTIVE: '#222222',
  BACKGROUND: '#FFFFFF',
}
const WIDTH = 33
const HEIGHT = 45
const CIRCLE_CENTER_HEIGHT = HEIGHT * 0.1
const DEFAULT_LINE_WIDTH = 3
const RADIUS = WIDTH / 2 - DEFAULT_LINE_WIDTH

const styles = {
  border: '1px solid #d3d3d3',
  borderRadius: '5px',
  width: WIDTH * 1.7,
}

export default class Dial extends React.Component {
  constructor(props) {
    super(props)
    // Setup refs
    this.canvasRef = React.createRef()
    this.container = React.createRef()
    this.unit = (this.props.max - this.props.min) / 100
    this.calculatedInitialValue = this._calculateValueFromNumber(this.props.initialValue)

    this.state = {
      value: this.calculatedInitialValue,
    }
    this.touchReference = null
  }

  _calculateValueFromNumber(number) {
    return (number - this.props.min) / this.unit - 50
  }

  _calculateNumberFromValue() {
    const number = (this.state.value + 50) * this.unit + this.props.min
    const rounded = Math.round(number / this.props.step)
    return rounded * this.props.step
  }

  componentDidMount() {
    this.container.current.addEventListener('mousedown', this._handleMouseDown)
    this.container.current.addEventListener('touchstart', this._handleTouchStart, false)
    this.context = this.canvasRef.current.getContext('2d')
    this.context.translate(WIDTH / 2, HEIGHT / 2)
    this._draw()
  }

  componentWillUnmount() {
    this.container.current.removeEventListener('mousedown', this._handleMouseDown)
    this.container.current.removeEventListener('touchstart', this._handleTouchStart)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      this.props.onChange(this._calculateNumberFromValue())
    }
    this._draw()
  }

  _handleMouseDown = e => {
    if (navigator.platform.includes('Mac')) {
      if (e.metaKey) this._reset()
    }
    if (navigator.platform.includes('Win')) {
      if (e.ctrlKey) this._reset()
    }
    window.addEventListener('mousemove', this._handleMouseMove)
    window.addEventListener('mouseup', this._handleMouseUp)
    e.preventDefault && e.preventDefault()
  }

  _handleMouseUp = e => {
    window.removeEventListener('mousemove', this._handleMouseMove)
    window.removeEventListener('mouseup', this._handleMouseUp)
    e.preventDefault && e.preventDefault()
  }

  _reset() {
    this.setState({ value: this.calculatedInitialValue })
  }

  _handleTouchStart = e => {
    this.touchReference = e.touches[0].pageY
    this.valueReference = this.state.value
    window.addEventListener('touchmove', this._handleTouchMove)
    window.addEventListener('touchend', this._handleTouchEnd)
    e.preventDefault && e.preventDefault()
  }

  _handleTouchMove = e => {
    const change = (e.touches[0].pageY - this.touchReference) * this.props.sensitivity
    this.setState(state => {
      let newValue = this.valueReference + change
      if (newValue > 50) newValue = 50
      if (newValue < -50) newValue = -50
      return { value: newValue }
    })
    e.preventDefault && e.preventDefault()
  }

  _handleTouchEnd = e => {
    window.removeEventListener('touchmove', this._handleTouchMove)
    window.removeEventListener('touchend', this._handleTouchEnd)
    e.preventDefault && e.preventDefault()
  }

  _handleMouseMove = e => {
    const change = e.movementY * -1 * this.props.sensitivity

    this.setState(state => {
      let newValue = state.value + change
      if (newValue > 50) newValue = 50
      if (newValue < -50) newValue = -50
      return { value: newValue }
    })
    e.preventDefault && e.preventDefault()
  }

  _draw() {
    this.context = this.canvasRef.current.getContext('2d')
    this.context.fillStyle = COLORS.BACKGROUND
    this.context.fillRect(-WIDTH, -HEIGHT, WIDTH * 2, HEIGHT * 2)

    // Draw the indicator triangle
    this.context.beginPath()
    this.context.fillStyle = COLORS.ACTIVE
    this.context.moveTo(0, -14)
    this.context.lineTo(5, -19)
    this.context.lineTo(-5, -19)
    this.context.fill()

    // Draw the circle
    this.context.fillStyle = COLORS.BACKGROUND
    this.context.beginPath()
    this.context.arc(0, CIRCLE_CENTER_HEIGHT, RADIUS, 0.65 * Math.PI, 2.35 * Math.PI)
    this.context.lineWidth = DEFAULT_LINE_WIDTH
    this.context.strokeStyle = COLORS.INACTIVE
    this.context.lineCap = 'round'
    this.context.stroke()

    // Draw the borderline
    this.context.beginPath()
    this.context.lineWidth = DEFAULT_LINE_WIDTH + 4
    this.context.strokeStyle = COLORS.BACKGROUND
    this._drawIndicatorLine()

    // Draw the indicator line
    this.context.beginPath()
    this.context.lineWidth = DEFAULT_LINE_WIDTH
    this.context.strokeStyle = COLORS.INACTIVE
    this.context.lineCap = 'round'
    this._drawIndicatorLine()
  }

  _drawIndicatorLine() {
    const rotation = (this.state.value * Math.PI) / 60
    this.context.translate(0, CIRCLE_CENTER_HEIGHT)
    this.context.moveTo(0, 0)
    this.context.rotate(rotation)
    this.context.lineTo(0, -RADIUS)
    this.context.stroke()
    this.context.rotate(-rotation)
    this.context.translate(0, -CIRCLE_CENTER_HEIGHT)
  }

  render() {
    return (
      <div ref={this.container} style={styles}>
        <div>{this.props.title}</div>
        <div>
          <canvas ref={this.canvasRef} width={WIDTH} height={HEIGHT} />
        </div>
      </div>
    )
  }
}
